import React,{Component} from 'react';

import classes from './Dyor.module.css';
class Dyor extends Component{

  componentDidMount() {
    window.scrollTo(0, 0)
  }

render() {
  return(
    <div className="card" style={{padding: "30px", textAlign: "left",width: "90%",marginLeft:"5%"}}>
    <h1>DYOR</h1>
    <h2>But how? How to do your own research?</h2>
    <p>Warning: There is absolutely no financial advice on this or on any other pages of this website. </p>
    <p>This is an article to explain how to do your own research.</p>
    <br></br>
    <p>
Without reading the solidity code of the contract you will never have 100% insurance on how a coin works, if it may be a scam or not. Investing in early crypto coin projects is equal to taking huge risks with your money.
<br></br>That being said, if you still want to try, below are a few reasonable things to do before doing a presale or buying a new crypto coin.
</p>
<br></br>
<p>
<b>To begin with, security audits are very important to check but you also need to verify the audits legitimacy too.</b>
 <br></br>However, most new coins have not been audited so you will need to do your own research. 
</p>
<br></br>
<p>
<b>First point: always check the contract address of the coin you are buying. Is this the same one you saw on coinhunt?</b>
<br></br> 
Before listing coins on coinhunt we do review them and try to eliminate scams (not a 100% science as we do not read the code) as much as we can, by using some requirements (See: https://coinhunt.cc/coinForm)
But sometimes scammers will submit a coin with a contract that does fit into our requirements, and they will announce another contract address on their telegram later on, a contract that would never get listed on our platform.
This is why, you should always double check if the contract address we display is the same with the one you are buying with. If not, something is wrong, you should probably run away.
</p>
<br></br>
<p>
<b>Here are some other important points to check:</b>
</p>
<br></br>
<p>
<b>Telegram:</b> Check if the number of members in the tg group is botted or not. You can clearly see this by comparing the number of online members to the total number of members.
If a telegram group has 8000 members but only a 100 online, chances are very high that it is botted, you may want to run away from these communities too..
</p>
<br></br>
<p>
<b>Bscscan:</b> Check the "Holder" tab, try to see the percentage the top holders have, if a wallet has more than 10% you may want to consider this too risky to invest.
This wallet could sell all of their coins, and it could have a huge impact (generally downwards) on the price. This can also cause panic and ultimately make everyone sell whatever they have.
There are exceptions to this rule, for example:
</p>
<p>
  - the locked pancakeswap liquidity 
  <br></br>
  - 0x000...00dead address which is for burning coins, meaning that noone can ever sell those coins
  <br></br>
  - in case of presale/prelaunch, the presale wallet can also have more than 10% (presales are obviously always more risky investments)
</p>
<br></br>
<p>
<b>Poocoin: </b> You can scan two particular scams via this website. You can check if there is a red warning message under the LP box, this box says something along "liquidity is not locked, the dev can take everything if they wish".
In that case, this coin can be a future rugpull, you may wanna run away. On poocoin, you can also check for honeypots. Under the graph, you have all the sell and buy orders, check if different addresses are able to sell.
Honeypot is a particular scam, where the developer has put a rule that only allows particular wallet adresses to sell, so if you only see buy orders and only a few sell orders (generally huge dumps), you may want to run away.
</p>
<br></br>
<p><b>Other than these more technical points,</b> a management and developer team that communicates properly and that is transparent, an always working website, clean social media accounts that are professionally managed are all good points to check before considering if you should run away or not.
 </p>
  </div>


  );
}

}
export default Dyor;